import { Outlet } from "react-router-dom";
import { Suspense, lazy } from "react";
import ThemeRegistry from "../theme";

const AddressSection = lazy(() => import("../components/AddressSection"));
const Navbar = lazy(() => import("../components/Navbar"));
const Footer = lazy(() => import("../components/Footer"));

export default function Layout() {
  return (
    <ThemeRegistry>
      <Suspense fallback={null}>
        <Navbar />
      </Suspense>
      
      {/* This is where the current route's content will be rendered */}
      <main>
        <Outlet />
      </main>
      <AddressSection />

        <Footer />
    </ThemeRegistry>
  );
}
